import { css } from '@emotion/react'
import { Checkbox, Text, VFlow } from 'bold-ui'
import { gray } from 'bold-ui/lib/styles/colors'
import { Box } from 'components/Box'
import { GruposProcedimentosSdcDto, Procedimento, ProcedimentoSdcDto } from 'graphql/types.generated'

import { TEXTO_ADICIONAL_EXAME_DENGUE_SDC } from '../utils/util-plano'

interface ExameSdcCheckboxProps {
  grupoExames: GruposProcedimentosSdcDto
  handleToggleProcedimento(procedimento: ProcedimentoSdcDto): void
  dataTestId?: string
  examesPreviamentePrescritos: Map<string, ProcedimentoSdcDto>
}

export function ExameSdcCheckbox(props: Readonly<ExameSdcCheckboxProps>) {
  const { grupoExames, handleToggleProcedimento, dataTestId, examesPreviamentePrescritos } = props
  const { titulo, procedimentosSdcDto } = grupoExames

  return (
    <Box>
      <VFlow>
        <Text fontWeight='bold'>{titulo}</Text>
        {procedimentosSdcDto.map((procedimento) => {
          const codigo = procedimento.exameSolicitado.codigo
          const isPreviamentePrescrito = examesPreviamentePrescritos.has(codigo)

          return (
            <VFlow vSpacing={0} key={codigo}>
              <span data-testid={dataTestId}>
                <Checkbox
                  label={formatLabel(procedimento.exameSolicitado)}
                  checked={isPreviamentePrescrito}
                  onChange={() => handleToggleProcedimento(procedimento)}
                  data-testid={`${dataTestId}-${codigo}`}
                />
              </span>
              {procedimento.observacao && <Text style={styles.observacao}>{procedimento.observacao}</Text>}
            </VFlow>
          )
        })}
      </VFlow>
    </Box>
  )
}

const formatLabel = (procedimento: Procedimento) => {
  const descricao = procedimento.procedimentoReferencia?.descricao || procedimento.descricao

  const textoFormatado = descricao.charAt(0).toUpperCase() + descricao.slice(1).toLowerCase()
  const textoComSubstituicoes = textoFormatado
    .replace(/\bigg\b/gi, 'IgG')
    .replace(/\bigm\b/gi, 'IgM')
    .replace('virus', 'vírus')

  const textoAdicional = TEXTO_ADICIONAL_EXAME_DENGUE_SDC.get(
    procedimento.procedimentoReferencia?.id || procedimento?.id
  )

  if (textoAdicional) {
    return (
      <div>
        {`${textoComSubstituicoes} `} <Text fontWeight='bold'>{textoAdicional}</Text>
      </div>
    )
  }

  return textoComSubstituicoes
}

const styles = {
  observacao: css`
    color: ${gray.c30};
    padding-left: 2.25rem;
  `,
}
